import { createError } from 'h3';
import type { ITimelineItem, ITimelineRequestBody, ITimelineRequestOptions, ITimelineResponse } from '~/types/types';
import { useJwtTokenStore } from '~/stores/jwtTokenStore';
import { reloadAppIfExpired } from '~/utils/TokenRefresher';
import { AbortError } from '~/utils/errors/AbortError';

export async function getTimelineData(locale: string, body: ITimelineRequestBody, signal?: AbortSignal): Promise<ITimelineItem[]> {
    const options: ITimelineRequestOptions = {
        headers: {
            'Authorization': `Bearer ${useJwtTokenStore().getMrApiToken}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Accept-Language': locale,
            'X-HTTP-METHOD-OVERRIDE': 'GET',
            'pagination': 'simple'
        },
        baseURL: useRuntimeConfig().public.timelineApi.url,
        method: 'post',
        body,
        signal
    };

    const { data } = await $fetch<ITimelineResponse>('/timeline', options).catch((error) => {
        if (signal?.aborted) {
            throw new AbortError();
        }

        if (reloadAppIfExpired(error.statusCode)) {
            return { data: [] };
        }

        throw createError({
            statusCode: 500,
            name: 'Account API Server Error',
            statusMessage: JSON.stringify(error.message),
        });
    });

    return data ?? [];
}
